import React from "react";
import RootLayout from "./RootLayout";
import whiteLogo from "../assets/images/logo-new.png";
import { Layout, Menu, Icon, Typography, Tooltip } from "antd";
import { TTranslate } from "../../service/locale/TranslationService";
import { TPresentable } from "../../presenter/withStore";
import { IUser } from "../../model/user/User";
import BreadCrumb from "../components/app/BreadCrumb";
import { RoleConstants } from "../../common/Constants";
import { IMenuItem } from "../../model/menu/MenuItem";

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

export interface Props {
  router: any;
  children?: any;
  translate: TTranslate;
  style?: any;
  params?: any;
}
export interface State extends TPresentable {}

export default class AppLayout extends React.Component<Props, State> {
  private subscriptionId: number = 0;
  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { children, translate, router, params } = this.props;

    const {
      user,
      roles,
      boMenuItems
    }: { user: IUser; roles: string[]; boMenuItems: IMenuItem[] } = this
      .state as any;
    const logoOnClickLink = "https://www.pravosudje.ba/";

    const MIK_OSOBLJE = RoleConstants.MIK_BO.MIK_OSOBLJE;
    const MIK_ADMIN = RoleConstants.MIK_BO.MIK_ADMIN;
    const MIK_OSOBLJE_PDNS = RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS;

    const onRenderBreadcrumbLabel = (this.state.store.getState() as any)
      .breadCrumb;
    const redirect = (path) => {
      window.location.href = path;
    };

    const checkPermissionsToAccess = (roleList: string[]) => {
      const permissionsToAccess = roles?.filter((role) =>
        roleList.includes(role)
      );
      return permissionsToAccess?.length > 0;
    };

    const displayMenuItem = (roleList: string[]) => {
      if (!checkPermissionsToAccess(roleList)) {
        return "none";
      }
    };

    const onSelectMenuItem = (menuItem: IMenuItem) => {
      redirect(menuItem.url);
    };

    const renderMenuItem = (menuItem: IMenuItem) => {
      return menuItem.children.length ? (
        <SubMenu
          key={menuItem.id}
          title={<span className="submenu-title-wrapper">{menuItem.name}</span>}
          style={{
            display: displayMenuItem([MIK_OSOBLJE, MIK_ADMIN])
          }}
        >
          {menuItem.children.map((child) => renderMenuItem(child))}
        </SubMenu>
      ) : (
        <Menu.Item
          key={menuItem.id}
          style={{
            flex: 1,
            flexDirection: "column",
            display: displayMenuItem([MIK_OSOBLJE, MIK_ADMIN])
          }}
          onClick={() => onSelectMenuItem(menuItem)}
        >
          <Tooltip title={menuItem.description}>{menuItem.name}</Tooltip>
        </Menu.Item>
      );
    };

    return (
      <RootLayout {...this.props}>
        <div className="base_layout">
          <Layout style={{ minHeight: "100vh" }}>
            <Header
              className="header"
              style={{ position: "fixed", zIndex: 2, width: "100%" }}
            >
              <div className="logo">
                <a href={logoOnClickLink} target={"_blank"}>
                  <img src={whiteLogo} alt="Logo" />
                </a>
              </div>
              <Menu
                theme="dark"
                mode="horizontal"
                selectable={false}
                defaultSelectedKeys={["1"]}
                style={{ lineHeight: "64px" }}
              >
                <Menu.Item
                  key="1"
                  style={{ float: "left" }}
                  onClick={() => redirect("/")}
                >
                  {translate("layout.back_office")}
                </Menu.Item>
                <SubMenu
                  key="sub2"
                  title={
                    <span>
                      <Icon type="table" />
                      <span>{translate("side_menu.codebooks")}</span>
                    </span>
                  }
                  style={{ display: displayMenuItem([MIK_ADMIN]) }}
                >
                  <Menu.Item
                    key="100"
                    onClick={() => redirect("/codebooks/menu-items")}
                  >
                    <span>{translate("side_menu.menu_items")}</span>
                  </Menu.Item>

                  <Menu.Item
                    key="codebook:11"
                    onClick={() => redirect("/codebooks/system-parameters")}
                  >
                    <span>{translate("side_menu.system_parameters")}</span>
                  </Menu.Item>

                  <Menu.Item
                    key="dynamic-queries"
                    onClick={() => redirect("/codebooks/dynamic-queries")}
                  >
                    <span>{translate("side_menu.dynamic_queries")}</span>
                  </Menu.Item>
                </SubMenu>
                <SubMenu
                  key="8"
                  title={
                    <span>
                      <Icon type="team" />
                      <span>{translate("side_menu.applicants")}</span>
                    </span>
                  }
                >
                  <Menu.Item
                    key="applicants:2"
                    onClick={() => redirect("/codebooks/roles")}
                    style={{ display: displayMenuItem([MIK_ADMIN]) }}
                  >
                    {translate("side_menu.roleTypes")}
                  </Menu.Item>
                  <Menu.Item
                    key="applicants:3"
                    onClick={() => redirect("/codebooks/positions")}
                    style={{ display: displayMenuItem([MIK_ADMIN]) }}
                  >
                    {translate("side_menu.positions")}
                  </Menu.Item>
                  <Menu.Item
                    key="applicants:1"
                    onClick={() => redirect("/registered-applicants")}
                    style={{
                      display: displayMenuItem([
                        MIK_ADMIN,
                        MIK_OSOBLJE,
                        MIK_OSOBLJE_PDNS
                      ])
                    }}
                  >
                    {translate("side_menu.all_applicants")}
                  </Menu.Item>
                </SubMenu>
                <SubMenu
                  title={
                    <span>
                      <Icon type="file-protect" />
                      <span>{translate("side_menu.reporting_periods")}</span>
                    </span>
                  }
                  key="9"
                >
                  <Menu.Item
                    key="reporting-period:4"
                    onClick={() => redirect("/codebooks/reporting")}
                    style={{
                      display: displayMenuItem([MIK_ADMIN])
                    }}
                  >
                    {translate("side_menu.reportingTypes")}
                  </Menu.Item>
                  <Menu.Item
                    key="reporting-period:5"
                    onClick={() => redirect("/codebooks/form-types")}
                    style={{
                      display: displayMenuItem([MIK_ADMIN])
                    }}
                  >
                    <span>{translate("side_menu.form_types")}</span>
                  </Menu.Item>
                  <Menu.Item
                    key="reporting-period:6"
                    onClick={() =>
                      redirect("/codebooks/form-types-group-categories")
                    }
                    style={{
                      display: displayMenuItem([MIK_ADMIN])
                    }}
                  >
                    <span>
                      {translate("side_menu.form_types_group_categories")}
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="reporting-period:12"
                    onClick={() => redirect("/codebooks/request-types")}
                    style={{
                      display: displayMenuItem([MIK_ADMIN])
                    }}
                  >
                    <span>{translate("side_menu.request_types")}</span>
                  </Menu.Item>
                  <Menu.Item
                    key="reporting-period:1"
                    onClick={() => redirect("/reporting-periods")}
                  >
                    {translate("side_menu.reporting_periods")}
                  </Menu.Item>
                  <Menu.Item
                    key="reporting-period:7"
                    onClick={() => redirect("/codebooks/attributes")}
                    style={{
                      display: displayMenuItem([MIK_ADMIN])
                    }}
                  >
                    {translate("side_menu.attribute_codebook")}
                  </Menu.Item>
                </SubMenu>
                <SubMenu
                  title={
                    <span>
                      <Icon type="security-scan" />
                      <span>{translate("side_menu.evaluations")}</span>
                    </span>
                  }
                  key="10"
                  style={{
                    display: displayMenuItem([MIK_ADMIN])
                  }}
                >
                  <Menu.Item
                    key="evaluations:7"
                    onClick={() => redirect("/codebooks/facts")}
                  >
                    <span>{translate("side_menu.facts")}</span>
                  </Menu.Item>
                  <Menu.Item
                    key="evaluations:8"
                    onClick={() => redirect("/codebooks/business-rules")}
                  >
                    <span>{translate("side_menu.business_rules")}</span>
                  </Menu.Item>
                  <Menu.Item
                    key="evaluations:9"
                    onClick={() => redirect("/codebooks/rule-groups")}
                  >
                    <span>{translate("side_menu.rule_groups")}</span>
                  </Menu.Item>
                  <Menu.Item
                    key="evaluations:10"
                    onClick={() => redirect("/codebooks/evaluation-types")}
                  >
                    <span>{translate("side_menu.evaluation_types")}</span>
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  title={
                    <span>
                      <Icon type="pie-chart" />
                      <span>{translate("side_menu.reports")}</span>
                    </span>
                  }
                  key="12"
                  style={{
                    display: displayMenuItem([MIK_OSOBLJE])
                  }}
                >
                  <Menu.Item
                    key="reports:1"
                    onClick={() => redirect("/reports/1")}
                  >
                    <Tooltip title={translate("reports.report_1")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`1 - `}</Typography.Text>
                        {translate("reports.report_1")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:2"
                    onClick={() => redirect("/reports/2")}
                  >
                    <Tooltip title={translate("reports.report_2")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`2 - `}</Typography.Text>
                        {translate("reports.report_2")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:3"
                    onClick={() => redirect("/reports/3")}
                  >
                    <Tooltip title={translate("reports.report_3")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`3 - `}</Typography.Text>
                        {translate("reports.report_3")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:4"
                    onClick={() => redirect("/reports/4")}
                  >
                    <Tooltip title={translate("reports.report_4")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`4 - `}</Typography.Text>
                        {translate("reports.report_4")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:5"
                    onClick={() => redirect("/reports/5")}
                  >
                    <Tooltip title={translate("reports.report_5")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`5 - `}</Typography.Text>
                        {translate("reports.report_5")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:6"
                    onClick={() => redirect("/reports/6")}
                  >
                    <Tooltip title={translate("reports.report_6")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`6 - `}</Typography.Text>
                        {translate("reports.report_6")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:7"
                    onClick={() => redirect("/reports/7")}
                  >
                    <Tooltip title={translate("reports.report_7")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`7 - `}</Typography.Text>
                        {translate("reports.report_7")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:8"
                    onClick={() => redirect("/reports/8")}
                  >
                    <Tooltip title={translate("reports.report_8")}>
                      <span>
                        <Typography.Text
                          strong
                          style={{
                            marginRight: 3,
                            color: "rgba(255, 255, 255, 0.65)"
                          }}
                        >{`8 - `}</Typography.Text>
                        {translate("reports.report_8")}
                      </span>
                    </Tooltip>
                  </Menu.Item>
                  <Menu.Item
                    key="reports:publications"
                    onClick={() => redirect("/reports/publications")}
                  >
                    <Tooltip title={translate("reports.publications_report")}>
                      <span>{translate("reports.publications_report")}</span>
                    </Tooltip>
                  </Menu.Item>
                </SubMenu>
                {(boMenuItems || []).map((menuItem) =>
                  renderMenuItem(menuItem)
                )}

                <SubMenu
                  style={{ float: "right" }}
                  title={
                    user && (
                      <span>
                        {translate("app_layout.signed_as")}
                        <strong> {user.username}</strong>
                      </span>
                    )
                  }
                >
                  <Menu.Item
                    key="setting:1"
                    onClick={() => redirect("/settings")}
                  >
                    <span>
                      <Icon type="setting" />
                      {translate("app_layout.settings")}
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="setting:2"
                    onClick={() => redirect("/dologout")}
                  >
                    <span>
                      <Icon type="logout" />
                      {translate("app_layout.logout")}
                    </span>
                  </Menu.Item>
                </SubMenu>
              </Menu>
            </Header>
            <Layout style={{ marginTop: 64 }}>
              <Layout
                style={{
                  padding: "0 24px 24px",
                  marginLeft: 0
                }}
              >
                <BreadCrumb
                  params={params}
                  router={router}
                  translate={translate}
                  onRenderLabel={onRenderBreadcrumbLabel}
                />

                <Content
                  style={Object.assign(
                    {},
                    {
                      background: "#fff",
                      padding: 24,
                      margin: 0,
                      minHeight: 280
                    },
                    this.props.style || {}
                  )}
                >
                  {children}
                </Content>
                <Footer style={{ textAlign: "center" }}>
                  {`© ${new Date().getFullYear()} Visoko sudsko i tužilačko vijeće`}
                </Footer>
              </Layout>
            </Layout>
          </Layout>
        </div>
      </RootLayout>
    );
  }
}
